import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CheckOPDList, OPD } from '../models/check-opd.model';
import { APP, AppResponse } from '../../../shared/models/app.model';
import { getFullUrl, getParams } from '../../../shared/utils/utils';
import { endpoint } from '../../../../enviroment/endpoint';

@Injectable({
  providedIn: 'root'
})
export class OPDService {
  httpClient = inject(HttpClient);

  getCheckOPD(param: any): Observable<AppResponse<CheckOPDList>> {
    const url = getFullUrl(endpoint.queue.url);
    return this.httpClient.get<AppResponse<CheckOPDList>>(url, { params: getParams(param) });
  }

  getOPDDetail(docNo: string): Observable<AppResponse<OPD>> {
    const headers = new HttpHeaders().set(APP.SPINNER_LOADER, '0');
    const url = getFullUrl(endpoint.opd.url, endpoint.opd.detail, { docNo });
    return this.httpClient.get<AppResponse<OPD>>(url, {
      headers: headers
    });
  }

  saveOPD(payload: OPD): Observable<AppResponse<OPD>> {
    const url = getFullUrl(endpoint.opd.url, endpoint.opd.save);
    return this.httpClient.post<AppResponse<OPD>>(url, payload);
  }

  cancelOPD(docNo: string): Observable<any> {
    const url = getFullUrl(endpoint.opd.url, endpoint.opd.cancel, { docNo });
    return this.httpClient.delete<any>(url);
  }

  examining(docNo: string): Observable<any> {
    const url = getFullUrl(endpoint.opd.url, endpoint.opd.examining, { docNo });
    return this.httpClient.put<any>(url, null);
  }
}
